import { exists } from '@/api'

export interface OldName {
  id: number
  name: string
  nameKana: string
}

export function OldNameFromJSON(json: any): OldName {
  return {
    id: json.id,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : ''
  }
}

export function OldNameToJSON(value: OldName): any {
  return {
    id: value.id,
    name: value.name,
    name_kana: value.nameKana
  }
}
